import React from 'react'

const QAdminPage = () => {
  return (
    <div className='min-h-dvh'>
        <div className='container flex flex-col gap-10 py-12'>
            <img src="/images/qadmin-logo.png" alt="QAdmin Logo" className='h-24 -translate-x-4 w-fit'/>
            <p className='sr-only'>QAdmin</p>

            <p className='max-w-5xl text-balance'>Je gebruikt nog geen softwarepakket om facturen aan te maken? Of maakt jouw facturen in Excel, Word of PDF-formaat? Met QAdmin ben je klaar voor de toekomst.</p>

            <div>
                <h2 className='mb-2 text-xl font-bold'>Gemakkelijk en snel factureren?</h2>
                <p className='text-balance'>QAdmin biedt een eenvoudige en zeer gebruiksvriendelijke applicatie om je bij te staan bij de facturatie en opvolging van facturen. Geen ingewikkelde technisch pakket en geen zware installaties, dat is QAdmin.</p>
            </div>

            <div>
                <h2 className='mb-2 text-xl font-bold'>QAdmin in het kort:</h2>
                <ul className='flex flex-col gap-2 ml-4 list-disc'>
                    <li>Verlies geen tijd met facturatie. Eenvoudig facturen en creditnota’s aanmaken, check!</li>
                    <li>Eerste stappen bij automatisatie. Betalingen opvolgen en herinneringen sturen doe je automatisch</li>
                    <li>Gecentraliseerd: aankoopfacturen, verkoopfacturen en andere documenten beheren in één enkele applicatie</li>
                    <li>Volledig Peppol-proof</li>
                    <li>Relaties beheren: zowel voor klanten, leveranciers als prospecten</li>
                    <li>Artikels beheren</li>
                    <ul className='ml-4 list-disc'>
                        <li>Beheer producten of diensten en koppel jouw eventuele voorraad aan de artikelen.</li>
                        <li>Via werkprestaties of tijdsregistratie geef je eenvoudig jouw gewerkte uren in</li>
                    </ul>
                    <li>Digitaliseer: koppel QAdmin eenvoudig aan jouw mailbox</li>
                </ul>
            </div>

            <div className='grid gap-4 md:gap-8 md:grid-cols-3'>
                <div className='p-4 border border-t-2 border-t-legoOrange'>
                    <p className='font-medium text-center'>60 EUR per maand (QAdmin)</p>
                </div>
                <div className='p-4 border border-t-2 border-t-legoOrange'>
                    <p className='font-medium text-center'>Eenmalige opstartkost inclusief opleiding: 399 EUR</p>
                </div>
                <div className='p-4 border border-t-2 border-t-legoOrange'>
                    <p className='font-medium text-center'>70 EUR per maand (QAdmin inclusief Peppol e-facturatie)</p>
                </div>
            </div>

            <div>
                <p className='font-semibold text-center'>Er is geen limiet op het aantal documenten.</p>
                <p className='text-center'>Er zijn 2 gebruikers in de prijs inbegrepen. Meer gebruikers nodig? Een extra gebruiker kost 6 EUR.</p>
            </div>

            <div className='flex flex-col items-center gap-4 p-6 bg-legoOrange'>
                <p className='font-medium text-white'>Laat het eenvoudig factureren beginnen Ik wil starten!</p>
                <button className='px-3 py-2 font-medium bg-white text-legoOrange min-h-10'>Ik wil starten!</button>
            </div>

            <div className='flex flex-col items-center gap-4'>
                <p><strong>Liever eerst een demo zien?</strong> Maak een afspraak met ons team</p>
                <a className='px-3 py-2 font-medium text-white bg-legoOrange min-h-10' href="https://outlook.office.com/bookwithme/user/455ff4396980438a8540b0001256a510%404e3ed852-201e-495a-a74c-7d4963db4dd6/meetingtype/c845902f-b4c8-48c9-b83c-d4fda5cfae40?anonymous">
                Boek een afspraak
                </a>
            </div>
        </div>
    </div>
  )
}

export default QAdminPage